import { type AdminUserSummary, apiErrorDetail, apiErrorStatus } from "@/lib/api";

interface Named {
  email: string;
  first_name?: string | null;
  last_name?: string | null;
}

/** Active staff and admin profiles not yet in `taken` (the engagement's assigned staff). */
export function staffCandidates(users: AdminUserSummary[], taken: Set<string>) {
  return users.filter(
    (u) => (u.role === "staff" || u.role === "admin") && !u.disabled_at && !taken.has(u.id),
  );
}

/** Active client profiles not yet in `taken` (the workspace's members). */
export function clientCandidates(users: AdminUserSummary[], taken: Set<string>) {
  return users.filter((u) => u.role === "client" && !u.disabled_at && !taken.has(u.id));
}

/** "First Last (email)", or just the email when the profile has no name. */
export function personLabel(person: Named): string {
  const name = `${person.first_name ?? ""} ${person.last_name ?? ""}`.trim();
  return name ? `${name} (${person.email})` : person.email;
}

/** The copy for a failed workspace action, from the API's error detail. */
export function workspaceErrorMessage(err: unknown): string {
  switch (apiErrorDetail(err)) {
    case "client_in_other_workspace":
      return "This client already belongs to another workspace. A client user can be in one workspace only.";
    case "target_not_client":
      return "That user is not an active client account.";
    case "target_not_staff":
      return "That user is not an active BOI staff account.";
    case "Workspace service unavailable":
      return "The workspace service is unavailable. Try again in a moment.";
    case "Admin access required":
      return "Only admins can do this.";
    default:
      break;
  }
  const status = apiErrorStatus(err);
  if (status === 404) {
    return "This workspace or engagement no longer exists.";
  }
  if (status === 422) {
    return "Check the fields: each name needs 1 to 200 characters.";
  }
  return "Something went wrong. Please try again.";
}
